import { render, staticRenderFns } from "./XInput.vue?vue&type=template&id=2b5d6c9f&scoped=true"
import script from "./XInput.vue?vue&type=script&lang=js"
export * from "./XInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5d6c9f",
  null
  
)

export default component.exports